export enum AvailableCTAs {
    FINANCING = 'FINANCING',
    BOOKING = 'BOOKING',
    RESERVE = 'RESERVE',
    NOTIFY_ME = 'NOTIFY_ME',
    // { ACTION KEY : ACTION ENUM}
}
